<image-cropper
  [imageFile]="imageFile"
  [maintainAspectRatio]="maintainAspectRatio"
  [aspectRatio]="aspectRatio"
  [output]="cropperOutputType"
  format="png"
  (imageCropped)="imageCropped($event)"
></image-cropper>
